import { FaInfoCircle } from "react-icons/fa";

type ProfileHistoryModalProps = {
  setIsProfileHistoryModalOpen: (open: boolean) => void;
  profile: any;
  packageDetails: any;
};

const ProfileHistoryModal = ({
  setIsProfileHistoryModalOpen,
  profile,
  packageDetails,
}: ProfileHistoryModalProps) => {
  // Update getServicePreferenceDisplay to only show the current service preference
  const getServicePreferenceDisplay = () => {
    if (!packageDetails) return "";
    const serviceMap: any = {
      only_online: "Only Online Service",
      only_offline: "Only Offline Service",
      online_offline: "Online & Offline Service",
    };
    return serviceMap[packageDetails.servicePreference] || "";
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-6 w-96 max-w-md mx-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold flex items-center">
            <FaInfoCircle className="mr-2 text-blue-600" />
            Profile History
          </h2>
          <button
            onClick={() => setIsProfileHistoryModalOpen(false)}
            className="text-gray-500 hover:text-gray-700 text-xl"
          >
            ×
          </button>
        </div>
        <div className="space-y-3">
          <div className="flex items-center">
            <span className="font-semibold w-32">Created:</span>
            <span>
              {profile.createdAt
                ? new Date(profile.createdAt).toLocaleDateString()
                : "N/A"}
            </span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold w-32">Service:</span>
            <span>{getServicePreferenceDisplay() || "N/A"}</span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold w-32">Membership:</span>
            <span>{profile.paymentStatus === "paid" ? "Paid" : "Free"}</span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold w-32">Views:</span>
            <span>{profile.views ?? 0}</span>
          </div>
        </div>
        <div className="flex space-x-3 mt-6">
          <button
            onClick={() => setIsProfileHistoryModalOpen(false)}
            className="flex-1 px-6 py-3 bg-gray-200 text-gray-800 rounded-lg font-medium hover:bg-gray-300 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileHistoryModal;
